// src/pages/Dashboard/Finance/Payroll/DentalReport.jsx
import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { useTranslation } from "react-i18next";

const DentalReport = ({ dentalData = {} }) => {
  const { t } = useTranslation();
  const data = [
    { name: t("finance.totalAmount"), value: Number(dentalData.total_amount) || 0 },
    { name: t("finance.collectedAmount"), value: Number(dentalData.collected_amount) || 0 },
    { name: t("finance.remainingAmount"), value: Number(dentalData.remaining_amount) || 0 },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.dentalReport")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 20, right: 20, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#82ca9d" barSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default DentalReport;
